<template>
  <div>
    <MasterLayout>
      <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row">
        <div class="row">
          <div class="col-md-8">
            <div class="py-5 pt-5 mb-3 row align-items-center white-bg">
              <div class="col-md-1 remove-right-padding col-center-flex">
                <div class="square-icon-wrapper small sky-bg">
                  <img src="@/assets/img/id-card.png" width="35" />
                </div>
              </div>
              <div class="py-1 col-md-6">
                <h4 class="primary-color font-600">
                  {{ $t("text.shiftAssignments.manageShiftAss") }}
                </h4>
                <p class="mt-3 light-grey-text">
                  {{ $t("text.shiftAssignments.description") }}
                </p>
              </div>
              <div class="col-md-5 flexify"></div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="py-4 card_container">
              <div class="card__header___text">
                <div>
                  <h3 class="text-center our_branches__header">
                    {{ $t("text.shiftAssignments.totalStaffs") }}
                  </h3>
                  <div class="mt-3 dealer__icon__wrapper">
                    <div class="text-center dealer__icon__div">
                      <div>
                        <img src="@/assets/img/id-card.png" width="35" />
                      </div>
                    </div>
                  </div>
                  <h3 class="mt-2 text-center our_branches__header">
                    {{ shiftNo }}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="mt-3 pump__details__section_2">
        <div class="row add_driver_row">
          <div
            :class="[
              $route.query.closed == 'true' || $route.query.closed == true
                ? 'col-lg-12'
                : 'col-lg-8',
            ]"
          >
            <table v-if="showLoader" style="margin: 0 auto; width: 95%">
              <tbody>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
                <tr>
                  <td class="td-1"><span></span></td>
                  <td class="td-2"><span></span></td>
                  <td class="td-3"><span></span></td>
                  <td class="td-4"></td>
                  <td class="td-5"><span></span></td>
                </tr>
              </tbody>
            </table>
            <ejs-grid
              v-show="!showLoader"
              ref="dataGrid"
              :created="refreshGrid"
              :allowPaging="true"
              :allowSorting="true"
              :pageSettings="pageSettings"
              :toolbar="toolbar"
              :searchSettings="search"
              :allowExcelExport="true"
              :allowPdfExport="true"
              :toolbarClick="toolbarClick"
              :rowDataBound="rowDataBound"
              :locale="usedLang"
            >
              <e-columns>
                <e-column width="40" field="index" headerText="#"></e-column>
                <e-column
                  field="pumpName"
                  width="200"
                  :headerText="$t('text.shiftAssignments.pumpName')"
                ></e-column>
                <e-column
                  field="name"
                  width="200"
                  :headerText="$t('text.shiftAssignments.staffName')"
                ></e-column>
                <e-column
                  width="180"
                  field="openingReading"
                  :headerText="$tc('text.shiftAssignments.openingReading', 1)"
                ></e-column>
                <e-column
                  width="180"
                  field="closingReading"
                  :headerText="$t('text.shiftAssignments.closingReading')"
                ></e-column>
                <e-column
                  :template="template"
                  width="250"
                  headerText="Action"
                ></e-column>
                <!-- <e-column width="250"  :template="actionButtonsTemplate"  headerText="Action"></e-column> -->
              </e-columns>
            </ejs-grid>
          </div>
          <div
            class="col-md-12 col-lg-4"
            v-if="
              $route.query.closed == 'false' || $route.query.closed == false
            "
          >
            <div style="background: white">
              <h3
                class="text-center primary_text"
                style="padding-top: 15px; font-size: 20px"
              >
                {{ $t("text.shiftAssignments.startNew") }}
              </h3>
              <div
                class="input__group__block mt-4"
                style="margin: 0 auto; width: 80%"
              >
                <label class="required">
                  {{ $t("text.shiftAssignments.pump") }}
                </label>
                <div class="input__block" ref="target_input_div">
                  <select v-model="pump" v-on:click="pumpChange">
                    <option disabled>
                      {{ $t("text.shiftAssignments.selectPump") }}
                    </option>
                    <option
                      :value="pump.id"
                      v-for="(pump, i) in pumps"
                      :key="i"
                    >
                      {{ pump.displayName }}
                    </option>
                  </select>
                </div>

                <div ref="target_error"></div>
              </div>
              <div
                class="input__group__block mt-4"
                style="margin: 0 auto; width: 80%"
              >
                <label class="required">
                  {{ $t("text.shiftAssignments.staff") }}
                </label>
                <div class="input__block" ref="">
                  <select v-model="staff">
                    <option disabled>
                      {{ $t("text.shiftAssignments.chooseStaff") }}
                    </option>
                    <option
                      v-for="(staff, i) in staffs"
                      :key="i"
                      :value="staff.id"
                    >
                      {{ staff.firstName }} {{ staff.lastName }}
                    </option>
                  </select>
                </div>

                <!-- <div ref="cr_error"></div> -->
              </div>
              <!-- <div class="input__group__block mt-4" style="margin: 0 auto; width: 80%">
              <label class="required">
              {{$tc('text.shiftAssignments.openingReading', 2)}}
              </label>
              <div class="input__block" ref="cr_input">
                  <input
                      style="padding: 20px; width:100%"
                      type="number"
                      :placeholder="this.$tc('text.shiftAssignments.openingReading', 1)"
                      @blur="captureFormEvents($event)"
                      v-model="openingRead"
                      disabled
                  />
              </div>
            
              <div ref="cr_error"></div>
          </div> -->

              <div class="text-center py-3 mt-3">
                <button
                  class="sales_target_btn text-center"
                  @click="assignShift($event)"
                  :disabled="isButtonDisabled ? true : null"
                  :style="[
                    isButtonDisabled
                      ? { cursor: 'not-allowed' }
                      : { cursor: 'pointer' },
                  ]"
                >
                  {{ $t("text.shiftAssignments.assignShift") }}<span></span>
                </button>
                <img
                  src="@/assets/img/git_loader.gif"
                  style="display: none"
                  width="35px"
                  class="ml-3 loader"
                />
              </div>
              <div></div>
            </div>
          </div>
        </div>
        <!-- <AssignShift :shift="shift"></AssignShift> -->
      </section>
    </MasterLayout>
    <CloseShift :shift="shift"></CloseShift>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Credit-card-background-shallow-DOF.png";
import configObject from "@/config";
import CloseShift from "@/components/modals/shifts/close_shift.vue";
import CloseShiftTemp from "@/components/Templates/Shifts/closeShift.vue";
import countryProducts from "@/products";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
} from "@syncfusion/ej2-vue-grids";

export default {
  name: "Pump_Details",
  components: {
    MasterLayout,
    CloseShift,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport, Resize],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      openingRead: null,
      pumps: [],
      staffs: [],
      staff: this.$t("text.shiftAssignments.chooseStaff"),
      pump: this.$t("text.shiftAssignments.selectPump"),
      pumpId: this.$route.query.id,
      branch: {},
      shiftName: null,
      shift: {},
      tanks: [],
      backgroundUrl,
      shifts: [],
      formIsValid: false,
      isButtonDisabled: false,
      showLoader: true,
      branchId: null,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      transFilter: "Show All",
      shiftAssignments: [],
      assignedShiftId: 0,
      staffList: [],
      pumpList: [],
      shiftNo: null,
      shiftClosed: null,
      template: function () {
        return {
          template: CloseShiftTemp,
        };
      },
    };
  },
  created() {
    document.title = "Shift Management:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Shift Management:: ${branch.name} Retail Outlet`;
    });

    this.$eventHub.$on("_getShift", (shift) => {
      this.assignShift(shift);
    });
    this.$eventHub.$on("closeShift", (shift) => {
      this.shift = shift;
      this.$modal.show("closeShift");
      // console.log(shift)
      // this.closeThisShift(shift);
    });
    this.$eventHub.$on("refreshShiftsTable", (shift) => {
      this.getPumps();
      this.getShiftAssignments();
      // this.getStaffs();
      this.getShiftAssignments();
    });
  },
  beforeDestroy() {
    this.$eventHub.$off("_getShift");
    this.$eventHub.$off("closeShift");
    this.$eventHub.$off("refreshShiftsTable");
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  watch: {
    shiftClosed: function (newShift, oldShift) {
      if (newShift !== oldShift) {
        this.shiftClosed = newShift;
      }
    },
    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = this.branch.id;
      }
      if (this.branchId !== null) {
        this.getStaffs();
        this.getPumps();

        this.getStaffShifts();
        this.getShiftAssignments();

        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
      }
    },
  },
  mounted() {
    this.shiftClosed = this.$route.query.closed;
  },
  methods: {
    pumpChange(event) {
      this.openingRead = 0;
    },
    rowDataBound: function (args) {
      if (args.data["Closed"] === "true") {
        args.row.cells[4].innerHTML = "Shift Closed";
      }
    },
    getStaffShifts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/StaffShifts/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.shifts = response.data;
        })
        .catch((error) => {});
    },
    closeThisShift(shift) {
      this.shift = shift;
      this.$modal.show("closeShift");
    },
    assignShift(shift) {
      let shiftDetail = this.shifts.filter((sft) => sft.id === shift.id)[0];
      this.shift = shiftDetail;
      this.openAssignShiftModal();
    },
    openAssignShiftModal() {
      this.$modal.show("assignShift");
    },
    openCloseShift() {
      this.$modal.show("closeShift");
    },

    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    getStaffs() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Staff/BranchStaff/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.staffs = response.data;
          this.getShiftAssignments();
        })
        .catch((error) => {});
    },

    getPumps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Pumps/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          response.data.forEach((element) => {
            if (element.productName !== undefined) {
              if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product1
              ) {
                element.color = "#d8991c";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product2
              ) {
                element.color = "#0fce29";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product3
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            } else if (element.displayName !== undefined) {
              if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product1)
              ) {
                element.color = "#d8991c";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product2)
              ) {
                element.color = "#0fce29";
              } else if (
                element.displayName
                  .toLowerCase()
                  .includes(this.countryProducts.productsLower.product3)
              ) {
                element.color = "#00aced";
              } else if (
                element.productName.toLowerCase() ===
                this.countryProducts.productsLower.product4
              ) {
                element.color = "purple";
              }
            }
          });
          this.pumps = response.data;
          this.getShiftAssignments();
        })
        .catch((error) => {});
    },
    assignShift($event) {
      if (
        !this.pump ||
        this.pump === this.$t("text.shiftAssignments.selectPump")
      ) {
        this.$toast.open({
          message: this.$t("text.shiftAssignments.pumpMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (
        !this.staff ||
        this.staff === this.$t("text.shiftAssignments.chooseStaff")
      ) {
        this.$toast.open({
          message: this.$t("text.shiftAssignments.staffMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      // if(this.openingRead ) {
      //   this.$toast.open({
      //       message: this.$t('text.shiftAssignments.openingReadingMissing'),
      //       type: "error",
      //       duration: 5000
      //     });
      //   return;
      // }

      let data = {
        pumpId: this.pump,
        openingRead: parseFloat(this.openingRead),
        branchId: this.branchId,
        staffId: this.staff,
        shiftId: this.$route.query.id,
        // "shiftName": this.shif.name
      };

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Branch/AssignShift`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.shiftAssignments.successfullyAssigned"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.getShiftAssignments();
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.shiftAssignments.unsuccessfullyAssigned"),
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
    refreshLocalStorage() {},
    getShiftAssignments() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/ShiftAssignments/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.shiftAssignments = response.data;
          this.shiftNo = response.data.length;
          let index = 0;
          let staffInds = [];

          response.data.forEach((element) => {
            if (
              element.closingReading === null ||
              !element.closingReading ||
              element.closingReading === "null"
            ) {
              element.closed = false;
            } else {
              element.closed = true;
            }
          });
          response.data.forEach((element) => {
            element.index = ++index;
            element.name = element.firstName + "   " + "   " + element.lastName;

            if (element.closingReading === null) {
              // const newStaffs = this.staffs.filter(staff => staff.id !== element.staffId);
              const newPumps = this.pumps.filter(
                (pump) => pump.id !== element.pumpId
              );
              this.pumps = newPumps;
              // this.staffs = newStaffs;
            } else {
            }
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {});
    },
    convertThousand(request) {
      return request; //.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
